import React from 'react'
import { HybridLayoutDefaultRowWrapper } from './HybridLayoutDefaultRow'
import { HybridLayoutAssociatedWatchedRow } from './hybird-fields/HybridLayoutAssociatedWatchedRow'
import InsuranceInformationComponent from './static-rows-component/InsuranceInformationComponent'
import { HybridLayoutRowMapByRowTypePropsType } from './hybridLayout.types'
import { HYBRID_LAYOUT_ROW_TYPE } from '../../utils/constants'
import NovoInsuranceInformationComponent from './static-rows-component/NovoInsuranceInformationComponent'

export const HybridLayoutRowMapByRowType: React.FC<HybridLayoutRowMapByRowTypePropsType> =
  React.memo(
    ({
      row,
      entityId,
      recordId,
      index,
      formUniqueId,
      refetchTimer,
      refetchLogic,
      openAllAccordions,
      mode,
      task,
    }) => {
      switch (row?.rowType) {
        case HYBRID_LAYOUT_ROW_TYPE.BASE_LAYOUT:
          return (
            <HybridLayoutDefaultRowWrapper
              row={row}
              entityId={entityId}
              recordId={recordId}
              index={index}
              formUniqueId={formUniqueId}
              refetchTimer={refetchTimer}
              refetchLogic={refetchLogic}
              openAllAccordions={openAllAccordions}
              rootRowIndex={index}
              mode={mode}
              task={task}
            />
          )
        case HYBRID_LAYOUT_ROW_TYPE.ASSOCIATED_SINGLELOOKUP_LAYOUT:
          return (
            <div>
              <React.Fragment key={row.rowId}>
                <HybridLayoutAssociatedWatchedRow
                  row={row}
                  recordId={recordId}
                  index={index}
                  formUniqueId={formUniqueId}
                  refetchTimer={refetchTimer}
                  refetchLogic={refetchLogic}
                  parentEntityId={entityId}
                  openAllAccordions={openAllAccordions}
                  task={task}
                  mode={mode}
                />
              </React.Fragment>
            </div>
          )
        case HYBRID_LAYOUT_ROW_TYPE.INSURANCE_INFORMATION_COMPONENT:
          return (
            <div>
              <InsuranceInformationComponent
                dataId={recordId}
                entityId={entityId}
                mode={mode}
              />
            </div>
          )
        case HYBRID_LAYOUT_ROW_TYPE.INSURANCE_INFORMATION_COMPONENT_NOVO:
          return (
            <NovoInsuranceInformationComponent
              dataId={recordId}
              entityId={entityId}
              mode={mode}
            />
          )
        default:
          return null
      }
    }
  )
HybridLayoutRowMapByRowType.displayName = 'HybridLayoutRowMapByRowType'
